import React, { useCallback } from 'react';
import { Enum } from 'util/backendapi/models/api.interfaces';
import {
  NewReadingGapPanelView,
  NewReadingGapFormValues,
} from './NewReadingGapPanelView';
import { postApi } from 'util/backendapi/fetch';
import { SimpleObservationPoint } from 'util/backendapi/types/Model';
import { getCurrentDatetime } from 'util/dates';
import { useIsMounted } from 'util/hooks';

export type NewReadingGapPanelProps = {
  observationPoint: SimpleObservationPoint;
  readingDatetime: string;
  timeZone: string | null | undefined;
  hidePanel: () => void;
  onReadingGapAdded: () => void;
};

export function NewReadingGapPanel(props: NewReadingGapPanelProps) {
  const { hidePanel, onReadingGapAdded } = props;

  const isMounted = useIsMounted();

  const handleAddNewReadingGap = useCallback(
    async (values: NewReadingGapFormValues) => {
      await postApi('/comments/', {
        resourcetype: Enum.Comment_RESOURCE_TYPE.readingGap,
        comment_type: Enum.Comment_TYPE.analysis,
        observation_point: values.observation_point,
        content: values.comment,
        created_datetime: getCurrentDatetime(),
        at_datetime: values.reading_datetime,
      });
      if (isMounted()) {
        hidePanel();
        onReadingGapAdded();
      }
    },
    [hidePanel, onReadingGapAdded, isMounted]
  );
  return (
    <NewReadingGapPanelView
      {...props}
      onSubmit={handleAddNewReadingGap}
      onCancel={hidePanel}
    />
  );
}
